import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";

export function GetAll(search, accessToken, areaId = null, areaUId = null) {
  var payload = { search, areaId, areaUId };
  return {
    type: Pre.USER + Actions.ALL,
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function RefreshQuickAccessList(accessToken) {
  return {
    type: Pre.USER + Actions.GET_DEVICE_QUICK_ACCESS,
    accessToken,
    payload: {},
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function UpdateQuickAccessList(devices = [], accessToken) {
  return {
    type: Pre.USER + Actions.SET_DEVICE_QUICK_ACCESS,
    accessToken,
    payload: devices,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function UpdateQuickAccessListLocally(devices = []) {
  return {
    type: Pre.DEVICE + Actions.SET_DEVICE_QUICK_ACCESS,
    payload: devices,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function GetMemberAccessList(userMemberId, accessToken) {
  return {
    type: Pre.USER + Actions.GET_ACCESS_LIST,
    accessToken,
    payload: { userMemberId },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function SetMemberAccess(
  userMemberId,
  areaId = 0,
  areaUId = null,
  accessLevel,
  expireValue,
  expireUnit,
  accessToken,
  buildingId
) {
  var accessLevels = [
    { areaId, areaUId, accessLevel, expireValue, expireUnit },
  ];
  return {
    type: Pre.USER + Actions.SET_ACCESS_LIST,
    accessToken,
    payload: {
      userMemberId,
      buildingId,
      // using array of accessLevels to support batch assignment, currently accessLevels assign one by one.
      accessLevels,
    },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function RegisterCompleted(accessToken) {
  return {
    type: Pre.USER + Actions.REGISTER_COMPLETED,
    accessToken,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function RemoveUser(userId, accessToken) {
  return {
    type: Pre.USER + Actions.REMOVE,
    payload: { userMemberId: userId },
    accessToken,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function UpdateUser(
  userId,
  description,
  role,
  expireValue,
  expireUnit,
  accessToken
) {
  return {
    type: Pre.USER + Actions.UPDATE,
    payload: {
      userMemberId: userId,
      description,
      role,
      expireValue,
      expireUnit,
    },
    accessToken,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function UpdateExpireDate(userId, expireValue, expireUnit, accessToken) {
  return {
    type: Pre.USER + Actions.UPDATE_EXPIRE,
    payload: {
      userId,
      expireValue,
      expireUnit,
    },
    accessToken,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function clearNewUserCache() {
  return {
    type: Pre.USER + Actions.CLEAR_NEW_USER_CACHE,
    socket: {
      send: false,
    },
  };
}

export function NotifyUserModified(userId, accessToken) {
  return {
    type: Pre.USER + Actions.FORCE_MEMBER_INIT,
    accessToken,
    payload: {
      receiverId: userId,
      isModified: true,
    },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function ResetLogoutToggle() {
  return {
    type: Pre.USER + Actions.RESET_LOGOUT,
    payload: {},
    socket: { send: false },
  };
}
export function RemoveErrorLocally() {
  return {
    type: Pre.USER + Actions.REMOVE,
    payload: {},
    socket: { send: false, keepSocket: true },
  };
}

export function GetSessions(accessToken) {
  return {
    type: Pre.USER + Actions.GET_SESSIONS,
    payload: {},
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}

export function CloseSessions(accessToken, sessionId) {
  return {
    type: Pre.USER + Actions.CLOSE_SESSIONS,
    payload: { sessionId },
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}
